import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { CustomizedSwitches } from '../Switch/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { themeSelector } from '../../selectors/selectors';
import { toggleTheme } from '../../redux/appConfigurator/action';

interface ThemeToggleProps {
    isDarkMode?: boolean;
    onToggle?: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ isDarkMode, onToggle }) => {
    const currentTheme = useSelector(themeSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        // Apply the appropriate class based on the current theme
        document.body.classList.toggle('chakra-ui-light', currentTheme === 'light');
        document.body.classList.toggle('chakra-ui-dark', currentTheme === 'dark');
    }, [currentTheme]); // Re-run this effect when currentTheme changes

    return (
        <Stack direction="row" alignItems="center">
            <CustomizedSwitches
                id="toggle-icon"
                showIcon
                switchProps={{
                    color: 'primary',
                    centerRipple: true,
                    checked: currentTheme === 'dark',
                    value: currentTheme === 'dark',
                    onChange: () => {
                        dispatch(toggleTheme(currentTheme === 'dark' ? 'light' : 'dark'));
                        localStorage.setItem('theme_toggled', 'true');
                    },
                }}
            />
        </Stack>
    );
};

export { ThemeToggle };
